import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import PageTitle from 'components/common/PageTitle';
import IconWorkFlow from 'components/icons/IconWorkFlow';
import IconDocument from 'components/icons/IconDocument';
import IconUserSquare from 'components/icons/IconUserSquare';
import IconWorkspace from 'components/icons/IconWorkspace';
import IconCard from 'components/icons/IconCard';
import IconWysiwyg from 'components/icons/IconWysiwyg';
import IconStorage from 'components/icons/IconStorage';
import IconFileUpload from 'components/icons/IconFileUpload';
import IconTune from 'components/icons/IconTune';
import IconMenu from 'components/icons/IconMenu';
import Button from 'components/common/Button';

import SettingsNavigationItem from './SettingsNavigationItem';

const styles = theme => ({
  drawerPaper: {
    top: 64,
    width: 265,
    border: 'none',
    background: theme.palette.secondary['800'],
    transition: theme.transitions.create(['width'], {
      duration: theme.transitions.duration.short,
    }),
    [theme.breakpoints.down('sm')]: {
      width: 48,
      overflow: 'visible',
    },
  },
  drawerPaperCollapsed: {
    width: 0,
  },
  title: {
    margin: '16px 30px 20px 30px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  list: {
    padding: 0,
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 162px)',
    maxHeight: 'calc(100dvh - 162px)',
  },
  iconWorkFlow: {
    width: '20px',
    height: '20px',
    margin: '0 12px 0 0',
    color: 'inherit',
  },
  iconDocument: {
    width: '20px',
    height: '20px',
    margin: '0 12px 0 0',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 14,
    },
  },
  iconUserSquare: {
    width: '26px',
    height: '26px',
    margin: '0 10px 0 -3px',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 11,
    },
  },
  iconWorkspace: {
    width: '24px',
    height: '24px',
    margin: '0 11px 0 -2px',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 12,
    },
  },
  iconCard: {
    width: '24px',
    height: '24px',
    margin: '0 11px 0 -2px',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 12,
    },
  },
  iconWysiwyg: {
    width: '24px',
    height: '24px',
    margin: '0 11px 0 -2px',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 12,
    },
  },
  iconStorage: {
    width: '24px',
    height: '24px',
    margin: '0 11px 0 -2px',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 12,
    },
  },
  iconFileUpload: {
    width: '24px',
    height: '24px',
    margin: '0 11px 0 -2px',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 12,
    },
  },
  iconTune: {
    width: '24px',
    height: '24px',
    margin: '0 11px 0 -2px',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      margin: 12,
    },
  },
  button: {
    display: 'none',
    position: 'absolute',
    zIndex: 10,
    width: 48,
    height: 48,
    top: -57,
    right: 'auto',
    left: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconMenu: {
    width: 24,
    height: 24,
    marginTop: 7,
  },
});

const SettingsNavigation = ({
  width, expanded, onExpandCollapseButtonClick, account, classes, record, appInfo,
}) => {
  const lastRecordBeforeSettings = record.slice().reverse()
    .find(item => item.pathname.indexOf('settings') === -1
      && item.pathname.indexOf('profile') === -1);
  return (
    <Drawer
      open
      variant="permanent"
      classes={{
        paper: classNames(classes.drawerPaper, {
          [classes.drawerPaperCollapsed]: !expanded,
        }),
      }}
    >
      <Button
        variant="fab"
        className={classes.button}
        onClick={onExpandCollapseButtonClick}
      >
        <IconMenu
          className={classes.iconMenu}
        />
      </Button>
      <PageTitle
        className={classes.title}
        text="Settings"
        variant="button"
        color="white"
        href={lastRecordBeforeSettings ? lastRecordBeforeSettings.pathname : '/'}
      />
      <List
        className={classes.list}
      >
        <SettingsNavigationItem
          href="/settings/business"
          icon={(
            <IconDocument className={classes.iconDocument} />
          )}
          subMenu={[
            {
              name: 'General',
              href: '/settings/business/general',
            },
            {
              name: 'Facilities',
              href: '/settings/business/facilities',
            },
            {
              name: 'Claim MD Сredentials',
              href: '/settings/business/claim-md-credentials',
            },
            {
              name: 'Twilio Сredentials',
              href: '/settings/business/twilio-credentials',
            },
          ]}
        >
          Business
        </SettingsNavigationItem>
        {account.Roles.filter(item =>
          item.Name === 'Master Administrator' || item.Name === 'Administrator').length > 0 &&
          <Fragment>
            <SettingsNavigationItem
              href="/settings/users"
              icon={(
                <IconUserSquare className={classes.iconUserSquare} />
              )}
              subMenu={[
                {
                  name: 'Users',
                  href: '/settings/users',
                },
                {
                  name: 'Roles and Permissions',
                  href: '/settings/roles',
                },
              ]}
            >
              Users
            </SettingsNavigationItem>
            <SettingsNavigationItem
              href="/settings/workspace"
              icon={(
                <IconWorkspace className={classes.iconWorkspace} />
              )}
              subMenu={[
                {
                  name: 'Note Categories',
                  href: '/settings/workspace/note-categories',
                },
                {
                  name: 'Document Categories',
                  href: '/settings/workspace/document-categories',
                },
                {
                  name: 'Workflow Statuses',
                  href: '/settings/workspace/workflow-statuses',
                },
                {
                  name: 'Claim Statuses',
                  href: '/settings/workspace/claim-statuses',
                },
                {
                  name: 'Claim Codes',
                  href: '/settings/workspace/claim-adjustment-codes',
                },
              ]}
            >
              Workspace
            </SettingsNavigationItem>
          </Fragment>
        }
        <SettingsNavigationItem
          href="/settings/medical-sources"
          icon={(
            <IconStorage className={classes.iconStorage} />
          )}
          subMenu={[
            {
              name: 'Referrals',
              href: '/settings/medical-sources/referrals',
            },
            {
              name: 'Sales',
              href: '/settings/medical-sources/sales',
            },
            {
              name: 'Prescribers',
              href: '/settings/medical-sources/prescribers',
            },
            {
              name: 'HCPCS Codes',
              href: '/settings/medical-sources/hcpc',
            },
            {
              name: 'Diagnosis',
              href: '/settings/medical-sources/diagnosis',
            },
            {
              name: 'Payers',
              href: '/settings/medical-sources/payers',
            },
          ]}
        >
          Medical Data
        </SettingsNavigationItem>
        {account.Roles.filter(item =>
          item.Name === 'Master Administrator' || item.Name === 'Administrator').length > 0 &&
          <SettingsNavigationItem
            href="/settings/data-portability"
            icon={(
              <IconFileUpload className={classes.iconFileUpload} />
            )}
            subMenu={[
              {
                name: 'Patients',
                href: '/settings/data-portability/patient',
              },
              {
                name: 'Products',
                href: '/settings/data-portability/inventory',
              },
              {
                name: 'Pecos',
                href: '/settings/data-portability/pecos',
              },
              {
                name: 'Patient Map Payers',
                href: '/settings/data-portability/patient_map_payers',
              },
            ]}
          >
            Data Portability
          </SettingsNavigationItem>
        }
        <SettingsNavigationItem
          href="/settings/templates"
          icon={(
            <IconWysiwyg className={classes.iconWysiwyg} />
          )}
        >
          Templates
        </SettingsNavigationItem>
        <SettingsNavigationItem
          href="/settings/payment"
          icon={(
            <IconCard className={classes.iconCard} />
          )}
        >
          Payment Dashboard
        </SettingsNavigationItem>
        {(account.Roles.filter(item => item.Name === 'Master Administrator').length > 0
          && appInfo['APP NAME'] === 'alba') &&
          <SettingsNavigationItem
            href="/settings/system"
            icon={(
              <IconTune className={classes.iconTune} />
            )}
          >
            System
          </SettingsNavigationItem>
        }
      </List>
    </Drawer>
  );
};

SettingsNavigation.propTypes = {
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  record: PropTypes.arrayOf(PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  })).isRequired,
  appInfo: PropTypes.shape({
    'APP NAME': PropTypes.string,
  }).isRequired,
  classes: PropTypes.shape({
    drawerPaper: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
  }).isRequired,
};


const mapStateToProps = store => ({
  account: store.account,
  record: store.routerParams.record || [],
  appInfo: store.appInfo,
});

export default connect(mapStateToProps)(
  withStyles(styles)(withWidth()(SettingsNavigation)),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/SettingsNavigation/SettingsNavigation.js